import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color, toCurrency, mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';

const TERMS = {
  phoneNumber: '聯絡電話：',
  posName: 'POS：',
  staffName: '服務：',
  orderNumber: '訂單編號：',
  cash: '現金',
  card: '信用卡',
};

const Container = styled.div`
  padding: 16px;
  border: 1px solid ${color.border};
`;

const Title = styled.div`
  text-align: center;
`;

const Table = styled.table`
  margin: 16px auto;
  width: 100%;
  border: none;
  border-collapse: collapse;
`;

const TableAmount = styled.td`
  text-align: center;
`;

const TablePrice = styled.td`
  text-align: right;
`;

const Dl = styled.dl`
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 4px 0;
  border-bottom: 1px solid ${color.base};
  &:last-of-type {
    margin-bottom: 4px;
  }
`;

class Receipt extends React.PureComponent {
  static propTypes = {
    receipt: PropTypes.shape(),
  };

  static defaultProps = {
    receipt: {},
  };

  render() {
    const {
      method,
      totalDiscount,
      totalPrice,
      customPrice,
      tax,
      discountList,
      items,
      ...descriptions
    } = this.props.receipt;

    return (
      <Container>
        <Title>交易明細</Title>
        <div>
          {_.map(descriptions, (value, key) => (
            <React.Fragment key={key}>
              {_.get(TERMS, [key], '')}
              {value}
              <br />
            </React.Fragment>
          ))}
        </div>
        <Table>
          <tbody>
            {_.size(items) > 0 ? (
              _.map(items, ({ name, amount, price }, id) => (
                <tr key={id}>
                  <td>{name}</td>
                  <TableAmount>{amount}</TableAmount>
                  <TablePrice>{toCurrency(price)}</TablePrice>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">手動輸入訂單金額</td>
                <TablePrice>{toCurrency(customPrice)}</TablePrice>
              </tr>
            )}
            {_.map(discountList, ({ name, value }, index) => (
              <tr key={`discount-item-${index}`}>
                <td colSpan="2">{name}</td>
                <TablePrice>{toCurrency(-value)}</TablePrice>
              </tr>
            ))}
          </tbody>
        </Table>
        <Dl>
          <dt>支付：{_.get(TERMS, [method], '')}</dt>
        </Dl>
        <Dl>
          <dt>總折扣金額</dt>
          <dd>{toCurrency(-totalDiscount)}</dd>
        </Dl>
        <Dl>
          <dt>{tax.name}</dt>
          <dd>{toCurrency(tax.value)}</dd>
        </Dl>
        <Dl>
          <dt>結帳金額</dt>
          <dd>{toCurrency(totalPrice)}</dd>
        </Dl>
        <div>退換貨請攜帶發票明細</div>
      </Container>
    );
  }
}

export default connect(mapState(['receipt']))(Receipt);



// WEBPACK FOOTER //
// ./src/components/Receipt/Receipt.js